/* unplugin-vue-components disabled */import { render } from "./chat-composer.vue?vue&type=template&id=dd60dca6&scoped=true"
import script from "./chat-composer.vue?vue&type=script&lang=js"
export * from "./chat-composer.vue?vue&type=script&lang=js"

import "./chat-composer.vue?vue&type=style&index=0&id=dd60dca6&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd60dca6"],['__file',"src/pages/chats/chat-composer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "dd60dca6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('dd60dca6', __exports__)) {
    api.reload('dd60dca6', __exports__)
  }
  
  module.hot.accept("./chat-composer.vue?vue&type=template&id=dd60dca6&scoped=true", () => {
    api.rerender('dd60dca6', render)
  })

}


export default __exports__